const Error404Page = () => {
    return ( <>404</> );
}
 
export default Error404Page;